/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderPayablesProfile.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/order-payables-profile";

export class AutogenModelOrderPayablesProfile<RowType extends ModelRow> extends Endpoint<RowType, RowOrderPayablesProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderPayablesProfile extends ModelRow<RowOrderPayablesProfileFields> {
	constructor(values?: Partial<RowOrderPayablesProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderPayablesProfileFields {
	bo_reason_code: string;
	bo_reason_code_exclude: string;
	company_id: string;
	currency_type: string;
	cutoff_date: string;
	departments: string;
	departments_exclude: string;
	descr: string;
	frozen_payables: string;
	group_by_default: string;
	has_inv_recd_date: string;
	id: string;
	payee_ids: string;
	payee_ids_exclude: string;
	payee_status: string;
	payee_type: string;
	payment_method: string;
	payment_recipient: string;
	profile_color: string;
	show_frozen_payables: string;
	start_date: string;
	transaction_num: string;
	triumphpay_active: boolean;
}

